import Datepicker from "vanillajs-datepicker/Datepicker"
import pl from "vanillajs-datepicker/locales/pl"

export class Calendar
{
	calendars = document.querySelectorAll('[data-s~="Calendar"]')

    constructor(store)
    {
        this.store = store;
        this.events = this.store.data.service.Calendar.events;
    }

    prepareFormats(dateObj)
    {
        let day = dateObj.getDate();
        let month = dateObj.getMonth() + 1;
        let year = dateObj.getFullYear();
        day = (day < 10) ? `0${day}` : day;
        month = (month < 10) ? `0${month}` : month;

        return [
            `${day}.${month}.${year}`,
            `${year}-${month}-${day}`
        ];
    }

	run()
	{
        Object.assign(Datepicker.locales, pl)

        this.calendars.forEach(e => {
            new Datepicker(e, {
                "format": "dd.mm.yyyy",
                "language": "pl",
                "datesDisabled": (date, viewId) => {
                    let dateFormats = this.prepareFormats(date);
                    return (viewId === 0) ? !Object.values(this.events).includes(dateFormats[0]) : false;
                }
            }).element.addEventListener('changeDate', (data) => {
                if (data.detail.date) {
                    let dateFormats = this.prepareFormats(data.detail.date);
                    location.href = `/${this.store.slugs.calendar}/${dateFormats[1]}`;
                }
            });
		})
	}
}
